import { useState } from "react";
import { Hourglass, ArrowClockwise, SignOut, CircleNotch } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import { authApi } from "../lib/api";
import { Backdrop, AUTH_CARD } from "../pages/AuthPage";

export default function PendingApproval() {
  const { user, setUser, logout } = useAuth();
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    const u = await authApi.me().catch(() => null);
    if (u) setUser(u);
    setBusy(false);
  };
  const declined = user.approval === "declined";
  return (
    <div className="relative min-h-[100dvh] flex items-center justify-center px-4 py-10 overflow-hidden" data-testid="pending-approval-screen">
      <Backdrop />
      <div className={`${AUTH_CARD} animate-in fade-in slide-in-from-bottom-2 duration-500`}>
          <span className="h-12 w-12 rounded-2xl bg-primary/10 flex items-center justify-center">
            <Hourglass weight="duotone" className="h-6 w-6 text-primary" />
          </span>
          <h1 className="mt-6 text-3xl font-semibold tracking-tight" data-testid="pending-title">
            {declined ? "Request not approved" : "Waiting for approval"}
          </h1>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
            {declined
              ? "An admin declined this account request. Reach out to them if you think this was a mistake."
              : `Thanks, ${user.name?.split(" ")[0]}. An admin needs to approve your account before you can see the collection. You'll have full access as soon as they do.`}
          </p>
          <p className="mt-4 text-xs text-muted-foreground font-mono">{user.email}</p>
          <div className="mt-8 flex gap-2">
            {!declined && (
              <Button data-testid="pending-check-btn" className="rounded-full gap-1.5" onClick={check} disabled={busy}>
                {busy ? <CircleNotch className="h-4 w-4 animate-spin" /> : <ArrowClockwise className="h-4 w-4" />} Check again
              </Button>
            )}
            <Button data-testid="pending-signout-btn" variant="ghost" className="rounded-full gap-1.5" onClick={logout}>
              <SignOut className="h-4 w-4" /> Sign out
            </Button>
          </div>
      </div>
    </div>
  );
}
